import { AbilityProvider } from '@casl/react';
import { type ReactNode, useMemo } from 'react';

import { defineAbilityForClientRoles } from '@/authorization/app-ability';
import { userManagerConfig } from '@/configs/user-manager-config';
import { useUser } from '@/hooks/use-user';

type AppAbilityProviderProps = {
  children: ReactNode;
};

export function AppAbilityProvider({ children }: AppAbilityProviderProps) {
  const { user } = useUser();
  const ability = useMemo(() => {
    const roles = user?.clientRoles?.[userManagerConfig.client_id] ?? [];
    return defineAbilityForClientRoles(roles);
  }, [user]);

  return <AbilityProvider value={ability}>{children}</AbilityProvider>;
}
